import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from 'axios';

const baseUrl = process.env.REACT_APP_BASE_URL;

//action

export const insertAdminSaleEntry = createAsyncThunk('insertAdminSaleEntry', async (postData) => {

    try {
        const response = await axios.post(`${baseUrl}?apicall=insertAdminSaleEntry`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const AddItemsInAdsBill = createAsyncThunk('AddItemsInAdsBill', async (postData) => {

    try {
        const response = await axios.post(`${baseUrl}?apicall=AddItemsinAdminSaleBill`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});
export const AddItemsInStudBill = createAsyncThunk('AddItemsInStudBill', async (postData) => {

    try {
        const response = await axios.post(`${baseUrl}?apicall=AddItemsinStudentSaleBill`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const insertUserSaleEntry = createAsyncThunk('insertUserSaleEntry', async (postData) => {

    try {
        const response = await axios.post(`${baseUrl}?apicall=insertUserSaleEntry`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});
export const insertStudentSaleEntry = createAsyncThunk('insertStudentSaleEntry', async (postData) => {

    try {
        const response = await axios.post(`${baseUrl}?apicall=insertStudentSaleEntry`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const updateAdminSaleEntry = createAsyncThunk('updateAdminSaleEntry', async (postData) => {

    try {
        const response = await axios.post(`${baseUrl}?apicall=UpdateAdminSaleEdit`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const updateStudentSaleEntry = createAsyncThunk('updateStudentSaleEntry', async (postData) => {

    try {
        const response = await axios.post(`${baseUrl}?apicall=UpdateStudentSaleEdit`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const updateUserSaleEdit = createAsyncThunk('updateUserSaleEdit', async (postData) => {

    try {
        const response = await axios.post(`${baseUrl}?apicall=updateUserSaleEdit`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const updateItemEntry = createAsyncThunk('updateItemEntry', async (postData) => {
    try {
        const response = await axios.post(`${baseUrl}?apicall=updateItem`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchAdminSaleReport = createAsyncThunk('fetchAdminSaleReport ', async (postdata) => {
    try {
        const endpoint = `getReportONAdminsale`;
        const response = await axios.post(`${baseUrl}?apicall=${endpoint}`, postdata);

        return response.data;
    } catch (error) {
        throw error;
    }
});


export const fetchUserSaleData = createAsyncThunk('fetchUserSaleData', async (postData) => {
    try {
        const response = await axios.post(`${baseUrl}?apicall=getUserSaleData`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchUserSaleReport = createAsyncThunk('fetchUserSaleReport ', async (postdata) => {
    try {
        const endpoint = `getReportONUserSale`;
        const response = await axios.post(`${baseUrl}?apicall=${endpoint}`, postdata);

        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchAdminSaleData = createAsyncThunk('fetchAdminSaleData', async (id) => {
    try {
        const endpoint = id ? `getAdminSaleEntry&sId=${id}` : 'getAdminSaleEntry';
        const response = await axios.get(`${baseUrl}?apicall=${endpoint}`);

        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchStudentSaleData = createAsyncThunk('fetchStudentSaleData', async (id) => {
    try {
        const endpoint = id ? `getStudentSaleEntry&sId=${id}` : 'getStudentSaleEntry';
        const response = await axios.get(`${baseUrl}?apicall=${endpoint}`);
        console.log("API Response",response.data);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchCancelAdminSaleData = createAsyncThunk('fetchCancelAdminSaleData', async (id) => {
    try {
        const endpoint = id ? `getCancelAdminSaleReg&sId=${id}` : 'getCancelAdminSaleReg';
        const response = await axios.get(`${baseUrl}?apicall=${endpoint}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchStockItemSize = createAsyncThunk('fetchStockItemSize', async (id) => {
    try {
        let endpoint;

        if (id && id.fdt && id.tdt) {
            const { fdt, tdt } = id;
            endpoint = `getStockItemsDatesWise&fromdt=${fdt}&todt=${tdt}`;
        } else {
            endpoint = `getStockItemSizes`;
        }

        const response = await axios.get(`${baseUrl}?apicall=${endpoint}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});


export const fetchCommonStockReg = createAsyncThunk('fetchCommonStockReg', async () => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getStockCommonWithsize`);
        return response.data;
    } catch (error) {
        throw error;
    }
});


// export const fetchUserSaleData = createAsyncThunk('fetchUserSaleData', async ({ id, userId, fdt, tdt, schlId } = {}) => {
//     try {
//         let endpoint = (fdt && tdt || userId || schlId || id) ? `getUserSaleData` : `getUserSaleData`;

//         const params = [];
//         if (id) params.push(`userId=${id}`);
//         if (fdt) params.push(`fromdt=${fdt}`);
//         if (tdt) params.push(`todt=${tdt}`);
//         if (userId) params.push(`userId=${userId}`);
//         if (schlId) params.push(`schlId=${schlId}`);

//         const fullEndpoint = params.length > 0
//             ? `${endpoint}&${params.join('&')}`
//             : endpoint;

//         const response = await axios.get(`${baseUrl}?apicall=${fullEndpoint}`);
//         return response.data;
//     } catch (error) {
//         throw error;
//     }
// });


export const deleteAdminSale = createAsyncThunk('deleteAdminSale', async (id) => {
    try {
        const response = await axios.delete(`${baseUrl}?apicall=deleteAdminSaleInvoiceEntry&sId=${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const deleteStudentSale = createAsyncThunk('deleteStudentSale', async (id) => {
    try {
        const response = await axios.delete(`${baseUrl}?apicall=deleteStudentSaleInvoiceEntry&sId=${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const deleteStocksize = createAsyncThunk('deleteStocksize', async (id) => {
    const { stkId, itemId, size } = id;
    try {
        const response = await axios.delete(`${baseUrl}?apicall=deleteStockSizewise&stkId=${stkId}&itemId=${itemId}&size=${size}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const deleteUserSale = createAsyncThunk('deleteUserSale', async (id) => {
    const { userId, usId } = id;
    try {
        const response = await axios.delete(`${baseUrl}?apicall=deleteUserSaleEntry&usId=${usId}&userId=${userId}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});





const stockSlice = createSlice({
    name: 'stockData',
    initialState: {
        isLoading: false,
        adsale: null,
        studsale:null,
        itemsize: null,
        ursale: null,
        delAdmin: null,
        delsize: null,
        cancelAd: null,
        comStk: null,
        deluser: null,
        isError: false
    },

    extraReducers: (builder) => {

        builder.addCase(fetchAdminSaleData.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchAdminSaleData.fulfilled, (state, action) => {
            state.isLoading = false;
            state.adsale = action.payload;
        });
        builder.addCase(fetchAdminSaleData.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });
         builder.addCase(fetchStudentSaleData.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchStudentSaleData.fulfilled, (state, action) => {
            state.isLoading = false;
            state.studsale = action.payload;
        });
        builder.addCase(fetchStudentSaleData.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(fetchStockItemSize.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchStockItemSize.fulfilled, (state, action) => {
            state.isLoading = false;
            state.itemsize = action.payload;
        });
        builder.addCase(fetchStockItemSize.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        // builder.addCase(fetchUserSaleData.pending, (state, action) => {
        //     state.isLoading = true;
        // });
        // builder.addCase(fetchUserSaleData.fulfilled, (state, action) => {
        //     state.isLoading = false;
        //     state.ursale = action.payload;
        // });
        // builder.addCase(fetchUserSaleData.rejected, (state, action) => {
        //     console.log('Error', action.error.message);
        //     state.isError = true;
        // });

        builder.addCase(deleteAdminSale.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(deleteAdminSale.fulfilled, (state, action) => {
            state.isLoading = false;
            state.delAdmin = action.payload;
        });
        builder.addCase(deleteAdminSale.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });


        builder.addCase(deleteStocksize.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(deleteStocksize.fulfilled, (state, action) => {
            state.isLoading = false;
            state.delsize = action.payload;
        });
        builder.addCase(deleteStocksize.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });


        builder.addCase(fetchCancelAdminSaleData.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchCancelAdminSaleData.fulfilled, (state, action) => {
            state.isLoading = false;
            state.cancelAd = action.payload;
        });
        builder.addCase(fetchCancelAdminSaleData.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(fetchCommonStockReg.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchCommonStockReg.fulfilled, (state, action) => {
            state.isLoading = false;
            state.comStk = action.payload;
        });
        builder.addCase(fetchCommonStockReg.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(deleteUserSale.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(deleteUserSale.fulfilled, (state, action) => {
            state.isLoading = false;
            state.deluser = action.payload;
        });
        builder.addCase(deleteUserSale.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });
    }
});

export default stockSlice.reducer;
